import { connect } from 'react-redux';
import EditPatientInformation from 'components/EditPatientsInformation/EditPatientInformation';

import { patientSubmitEditForm } from 'store/actionCreators/patient';
import { getEditPatientsDob, getEditPatientsFormInitialValues } from 'store/selectors/patient';

const mapStateToProps = state => ({
  initialValues: getEditPatientsFormInitialValues(state),
  dob: getEditPatientsDob(state),
});

const mapDispatchToProps = {
  onSubmit: patientSubmitEditForm,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EditPatientInformation);
